import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { globalVar } from '@/helpers/globals';
import type { DataProvider } from '@/@types/data_provider';


export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  setup(__props) {

const dpData: Array<DataProvider> = globalVar('data_providers') || [];

const dataProviders = ref<Array<DataProvider>>(dpData);

return { __sfc: true,dpData, dataProviders }
}

})